// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCHF6ZXUeeUdExDhhy6sMd4W1eO8oyr0DU",
  authDomain: "techb-energy.firebaseapp.com",
  projectId: "techb-energy",
  storageBucket: "techb-energy.firebasestorage.app",
  messagingSenderId: "1024033340737",
  appId: "1:1024033340737:web:9cad3d7f75de754454b5c0",
  measurementId: "G-MYTS6WFR59"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// analytics (optional)
getAnalytics(app);

// 🔥 THIS IS WHAT YOU WERE MISSING
export const db = getFirestore(app);